/*
 * KundenCrmCard.tsx  CRM Informationen anzeigen.
 *
 * Created by Dr. Maximillian Dornseif 2023-10-12 in huWaWi3 33.1.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import { LadeChecker } from '@hudora/hd-react-components';
import { useQuery } from 'urql';

import { CRM_QUERY } from '../../Stammdaten/StammKundenAppQueries';
import { EntityCard } from './EntityCard';

interface KundenCardProps {
  /** Kundennummer. Wenn leer oder kein Kunde gefunden, wird auch nichts angezeigt.
   * */
  nr: string;
}

/** Anzeige von Informationen zu einer Kundennummer.
 *
 * Vor allem für die rechte Sidebar gedacht
 * */
export function KundenCrmCard(props: KundenCardProps) {
  const [result] = useQuery({
    query: CRM_QUERY,
    variables: { nr: props.nr },
  });
  const { data, fetching, error } = result;
  const sx = { fontSize: 12 };

  if (!props.nr) {
    return null;
  }

  return (
    <LadeChecker loading={fetching} error={error} data={data} label={`Lade Kunde`}>
      <EntityCard entity={data?.hwKunde?.entity} schemaName={'H3KundeInfo'} title="CRM" />
    </LadeChecker>
  );
}
